import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from "react";
import { RouterContext } from "./Router";
var Link = function (_a) {
    var to = _a.to, className = _a.className, onClick = _a.onClick, children = _a.children;
    var router_context = useContext(RouterContext);
    if (!router_context) {
        throw new Error("Link must be used inside a Router component");
    }
    var navigate = router_context.navigate;
    var handleClick = function (event) {
        event.preventDefault();
        onClick ? onClick() : navigate(to);
    };
    return _jsx("a", { href: to || "#", onClick: handleClick, className: className, children: children });
};
export { Link };
